import React from 'react';
import { ImageIcon } from '../../components/design/custom-icons.jsx';
import { CancelRequest, NewQuotation, QuotationReplied } from '../../routes/quotation';

export const QuotationSteps = [
    {
        title: 'New Quotation',
        icon: <ImageIcon src='steps/quotation-request.svg' />,
        status: 1,
        component: () => NewQuotation

    },
    {
        title: 'Visual Requested',
        icon: <ImageIcon src='steps/request-visual.svg' />,
        status: 3,
        component: () => NewQuotation
    },
    {
        title: 'Visual Recieved',
        icon: <ImageIcon src='steps/visual-recieved.svg' />,
        status: 4,
        component: () => NewQuotation
    },
    {
        title: 'Quotation Replied',
        icon: <ImageIcon src='steps/quotation-replied.svg' />,
        status: 2,
        component: () => QuotationReplied
    },
    {
        title: 'Cancelled',
        icon: <ImageIcon src='steps/quotation-rejected.svg' />,
        status: 5,
        component: () => CancelRequest
    },
]